export type StatusType = 'IMPORT' | 'EXPORT';

export interface StatusRow {
  id: number;
  type: StatusType;
  name: string;
  color: string | null;
  enabled: boolean;
}

export const EMPTY_DRAFT: Omit<StatusDraft, 'type'> = {
  name: '',
  color: null,
  enabled: true,
};

export const NEW_ROW_ID = -1;

export type StatusDraft = Omit<StatusRow, 'id'>;
